import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '@/lib/auth';
import { ThemeProvider } from '@/lib/theme';
import { ToastHostSingleton } from '@/components/ui/Toast';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { AdminLayout } from '@/components/layout/AdminLayout';
import { ClientLayout } from '@/components/layout/ClientLayout';
import { PageFallback } from '@/components/shared/Loading';

// Login va en el bundle principal (es el entry point tras redirect).
import { LoginPage } from '@/pages/auth/LoginPage';

// Code splitting: cada página pesa ~5-15 KB. Solo se carga la necesaria.
const AdminDashboard = lazy(() => import('@/pages/admin/Dashboard').then((m) => ({ default: m.AdminDashboard })));
const AdminClients = lazy(() => import('@/pages/admin/Clients').then((m) => ({ default: m.AdminClients })));
const ClientDetail = lazy(() => import('@/pages/admin/ClientDetail').then((m) => ({ default: m.ClientDetail })));
const AdminRecipes = lazy(() => import('@/pages/admin/Recipes').then((m) => ({ default: m.AdminRecipes })));
const AdminPlates = lazy(() => import('@/pages/admin/Plates').then((m) => ({ default: m.AdminPlates })));
const AdminMenus = lazy(() => import('@/pages/admin/Menus').then((m) => ({ default: m.AdminMenus })));
const AdminPlans = lazy(() => import('@/pages/admin/Plans').then((m) => ({ default: m.AdminPlans })));
const AdminSettings = lazy(() => import('@/pages/admin/Settings').then((m) => ({ default: m.AdminSettings })));

const ClientHome = lazy(() => import('@/pages/client/Home').then((m) => ({ default: m.ClientHome })));
const ClientLog = lazy(() => import('@/pages/client/Log').then((m) => ({ default: m.ClientLog })));
const ClientPhotos = lazy(() => import('@/pages/client/Photos').then((m) => ({ default: m.ClientPhotos })));
const ClientProgress = lazy(() => import('@/pages/client/Progress').then((m) => ({ default: m.ClientProgress })));
const ClientProfile = lazy(() => import('@/pages/client/Profile').then((m) => ({ default: m.ClientProfile })));

export function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <AuthProvider>
          <ToastHostSingleton>
            <Suspense fallback={<PageFallback />}>
              <Routes>
                <Route path="/login" element={<LoginPage />} />

                {/* Admin */}
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute role="ADMIN">
                      <AdminLayout />
                    </ProtectedRoute>
                  }
                >
                  <Route index element={<AdminDashboard />} />
                  <Route path="clientes" element={<AdminClients />} />
                  <Route path="clientes/:id" element={<ClientDetail />} />
                  <Route path="recetas" element={<AdminRecipes />} />
                  <Route path="platos" element={<AdminPlates />} />
                  <Route path="menus" element={<AdminMenus />} />
                  <Route path="planes" element={<AdminPlans />} />
                  <Route path="settings" element={<AdminSettings />} />
                </Route>

                {/* Cliente */}
                <Route
                  path="/app"
                  element={
                    <ProtectedRoute role="CLIENTE">
                      <ClientLayout />
                    </ProtectedRoute>
                  }
                >
                  <Route index element={<ClientHome />} />
                  <Route path="registrar" element={<ClientLog />} />
                  <Route path="fotos" element={<ClientPhotos />} />
                  <Route path="progreso" element={<ClientProgress />} />
                  <Route path="perfil" element={<ClientProfile />} />
                </Route>

                <Route path="/" element={<Navigate to="/login" replace />} />
                <Route path="*" element={<Navigate to="/login" replace />} />
              </Routes>
            </Suspense>
          </ToastHostSingleton>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}